import React, { useState, useEffect, useRef } from "react";
import "../../../../css/bs-stepper.css";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import {
  IconBriefcase,
  IconCategory,
  IconPhoto,
  IconBuilding,
  IconPalette,
  IconTool
} from "@tabler/icons-react";
import "../../MyInvitations/Common/FormCss.css";
import { useAuth } from "../../../Context/store/context";
import StepHeader from "../../MyInvitations/Common/Step-Header";
import { _delete, _get } from "../../../../apiClient";
import { _showToast } from "../../../../toastHelper";
import { fetchadmininfo } from "../../../Redux/Actions/AdmininfoAction";
import globals from "../../../../globals";
import Studios from "../../MyInvitations/Common/Studio/Studios";
import SeoDetails from "./Seo/Seo";
import About from "./About/About";
import Services from "./Services/Services";
import Gallery from "../../MyInvitations/Common/Gallery/Gallery";
import ThemeCustomization from "../../MyInvitations/Common/Customization/ThemeCustomization";
import Save from "./Save";
import FetchAndBindData from "./BindData";
import config from "../../../../config";
import getDefaultServices from "./Services/DefaultServices";

export default function WebsiteForm() {
  const navigate = useNavigate();
  const { themeId, id } = useParams();
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } =
    useAuth();
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const dispatch = useDispatch();
  const [deletedImages, setDeletedImages] = useState([]);
  const [categories, setCategories] = useState([]);

  const eventSections = [
    {
      title: "About",
      subTitle: "",
      data: null,
      isValid: false,
      sectionname: "about",
      icon: function () {
        return <IconCategory size={22} />;
      },
    },
    {
      title: "Services",
      subTitle: "",
      data: null,
      isValid: false,
      sectionname: "services",
      icon: function () {
        return <IconBriefcase size={22} />;
      },
    },
    {
      title: "Gallery",
      subTitle: "",
      data: null,
      isValid: false,
      sectionname: "gallery",
      icon: function () {
        return <IconPhoto size={22} />;
      },
    },
    {
      title: "Studio Profile",
      subTitle: "",
      data: null,
      isValid: false,
      sectionname: "studio",
      icon: function () {
        return <IconBuilding size={22} />;
      },
    },
    {
      title: "SEO Details",
      subTitle: "",
      data: null,
      isValid: false,
      sectionname: "seo",
      icon: function () {
        return <IconTool size={22} />;
      },
    },
    {
      title: "Customization",
      subTitle: "",
      data: null,
      isValid: false,
      sectionname: "theme",
      icon: function () {
        return <IconPalette size={22} />;
      },
    },
  ];

  const [sections, setSections] = useState([]);
  const [eventId, setEventId] = useState(0);
  const [eventCode, setEventCode] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const childRef = useRef();

  useEffect(() => {
    if (!getToken()) logoutuser();
    updateTitleAndIcon(globals.createWebsite.title, globals.createWebsite.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      if (id) {
        fetchandBindData(id);
      }
      else {
        eventSections.forEach((section) => {
          if (section.sectionname == "services")
            section.data = getDefaultServices();
        });

        setSections(eventSections);
      }
    }
  }, [userDetails, id]);

  const fetchandBindData = async (id) => {
    let result = await FetchAndBindData(id, eventSections);
    if (result) {
      setSections(result.sections);
      setEventId(result.websiteId);
      setEventCode(result.eventCode);
    } else return navigate("/dashboard");
  };

  const handleSectionClick = (e, step) => {
    e.preventDefault();
    if (validateForm()) {
      let nextStep = currentStep + 1;
      while (nextStep < step) {
        if (sections[nextStep].isValid) nextStep++;
        else {
          let section = sections[nextStep];
          _showToast(
            "Please provide information in " + section.title + " section",
            "warning"
          );
          return;
        }
      }
      getAndUpdateData();
      setCurrentStep(step);
    } else {
      _showToast(
        "Please provide information for all the required fileds before proceeding further",
        "warning"
      );
    }
  };

  const insertDeletedImage = (imageKey) => {
    setDeletedImages((current) => [...current, imageKey]);
  };

  const renderStep = () => {
    if (sections && sections.length > 0) {
      const section = sections[currentStep];
      switch (section.sectionname) {
        case "about":
          return (
            <About
              ref={childRef}
              data={section.data}
              index={currentStep}
              steps={sections.length}
              navigate={handleSectionClick}
              imageDelete={insertDeletedImage}
            />
          );
        case "services":
          return (
            <Services
              ref={childRef}
              data={section.data}
              index={currentStep}
              steps={sections.length}
              navigate={handleSectionClick}
              imageDelete={insertDeletedImage}
              categories={categories}
            />
          );
        case "gallery":
          return (
            <Gallery
              ref={childRef}
              data={section.data}
              index={currentStep}
              steps={sections.length}
              navigate={handleSectionClick}
              imageDelete={insertDeletedImage}
            />
          );
        case "studio":
          return (
            <Studios
              ref={childRef}
              data={section.data}
              index={currentStep}
              steps={sections.length}
              navigate={handleSectionClick}
              imageDelete={insertDeletedImage}
            />
          );
        case "seo":
          return (
            <SeoDetails
              ref={childRef}
              data={section.data}
              index={currentStep}
              steps={sections.length}
              navigate={handleSectionClick}
              imageDelete={insertDeletedImage}
            />
          );
        case "theme":
          return (
            <ThemeCustomization
              ref={childRef}
              data={section.data}
              index={currentStep}
              steps={sections.length}
              navigate={handleSectionClick}
              save={saveHandler}
              imageDelete={insertDeletedImage}
            />
          );
      }
    }
  };

  const validateForm = () => {
    sections[currentStep].isValid = childRef?.current?.validate() ?? false;
    return sections[currentStep].isValid;
  };

  const getAndUpdateData = () => {
    const updatedSections = [...sections];
    updatedSections[currentStep]["data"] = childRef?.current?.getData() ?? null;
    setSections(updatedSections);
  };

  const saveHandler = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      getAndUpdateData();
      showLoader();

      let result = await Save(
        [...sections],
        themeId,
        eventId,
        eventCode,
        deletedImages
      );
      hideLoader();
      if (result.status == "success") {
        if (!eventId || (eventId && eventId == 0))

          updateWebsiteId(result.websiteId);

        setEventCode(result.websiteCode);
        setEventId(result.websiteId);


        window.history.replaceState(
          null,
          "Edit Site | Invitd",
          "/website/" + result.websiteId
        );
        if (userDetails.domain && userDetails.domain.trim() != "")
          window.open(userDetails.domain, "_blank");
        _showToast(result.message, "success");
      } else {
        if (result.message != "") _showToast(result.message, "error");
      }
    } else {
      _showToast(
        "Please provide information for all the required fileds before proceeding further",
        "warning"
      );
    }
  };

  const updateWebsiteId = (websiteId) => {
    userDetails.profilePageId = websiteId;
    dispatch(fetchadmininfo(userDetails));
  };

  const handleDelteClicked = async () => {
    event.preventDefault();
    const confirmation = window.confirm(
      "Are you sure you want to delete this? This action cannot be undone."
    );

    if (confirmation) {
      showLoader();
      await _delete(`/profile-pages/${eventId}`)
        .then(async () => {
          hideLoader();
          _showToast("My website information deleted successfully", "success");
          updateWebsiteId(null);
          navigate("/create-website");
        })
        .catch((error) => {
          hideLoader();
          _showToast(error, "error");
        });
    }
  };

  const changeThemeHandler = () => {
    let url = `/change-website-theme/${eventId}/${config.websiteCategoryId}`;
    navigate(url);
  };

  const viewWebsiteHandler = () => {
    if (userDetails.domain && userDetails.domain.trim() != "")
      window.open(userDetails.domain, "_blank");
  }

  return (
    <div className="content-wrapper container-xxl flex-grow-1 container-p-y  ">
      <div className="card mb-3">
        <div className="card-body">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-style1 mb-0">
              <li className="breadcrumb-item ">
                <NavLink to="/dashboard" className="text-gray">
                  Dashboard
                </NavLink>
              </li>

              {eventId == 0 && (
                <>
                  <li className="breadcrumb-item">
                    <NavLink className="text-gray" to={"/create-website"}>
                      Select Theme
                    </NavLink>
                  </li>
                  <li className="breadcrumb-item text-primary">My Website</li>
                </>)}

              {eventId > 0 && (
                <li className="breadcrumb-item text-primary">My Website</li>
              )}
            </ol>
          </nav>
        </div>
      </div>

      {eventId > 0 && (
        <>
          <div className="grid gap-1 d-flex justify-content-end">
            <div className=" g-col-1">
              <button
                onClick={viewWebsiteHandler}
                className="btn btn-primary btn-next"
              >
                <span className="align-middle d-sm-inline-block d-none me-sm-1">
                  View Site
                </span>
              </button>
            </div>
            <div className=" g-col-1">
              <button
                onClick={changeThemeHandler}
                className="btn btn-primary btn-next"
              >
                <span className="align-middle d-sm-inline-block d-none me-sm-1">
                  Change Theme
                </span>
              </button>
            </div>
            <div className=" g-col-1">
              <button
                onClick={handleDelteClicked}
                className="btn btn-primary btn-next"
              >
                <span className="align-middle d-sm-inline-block d-none me-sm-1">
                  Delete Site
                </span>
              </button>
            </div>
          </div>
        </>
      )}

      <div className="bs-stepper wizard-vertical wizard-numbered vertical mt-2">
        <div className="bs-stepper-header">
          {sections.map((section, index) => {
            const isActive = index === currentStep;
            let backgroundcolor = "text-gray";

            if (isActive) {
              backgroundcolor = "text-red";
            } else if (section.isValid) {
              backgroundcolor = "text-green";
            }

            return (
              <StepHeader
                backgroundColor={backgroundcolor}
                Icon={section.icon}
                title={section.title}
                subTitle={section.subTitle}
                className={`step ${isActive ? "active" : ""}`}
                onClick={(e) => handleSectionClick(e, index)}
                key={index}
              />
            );
          })}
        </div>
        <div className="bs-stepper-content">{renderStep()}</div>
      </div>
    </div>
  );
}
